module.exports = "/call-frontend/img/icon_add_outline.4f84241d.svg";